var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "position-relative mx-1 flex-fill" }, [
    _c("i", {
      staticClass:
        "bi bi-search position-absolute top-50 start-0 translate-middle-y text-muted ps-2 small",
    }),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _setup.navSearch,
          expression: "navSearch",
        },
      ],
      staticClass: "form-control form-control-sm rounded-5 h-25",
      staticStyle: {
        "padding-left": "28px",
        "min-height": "auto",
        "font-size": "12px",
      },
      attrs: { type: "text" },
      domProps: { value: _setup.navSearch },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _setup.navSearch = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _setup.navSearch !== ""
      ? _c("i", {
          staticClass:
            "bi bi-x position-absolute top-50 end-0 translate-middle-y text-muted pe-2",
          attrs: { role: "button" },
          on: {
            click: function ($event) {
              _setup.navSearch = ""
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }